import * as Yup from "yup";

export const validateBrowserSettings = Yup.object().shape({
  per_page: Yup.number()
    .typeError("This field is required")
    .required("Required")
    .min(10, "Minimum value is 10")
    .max(50, "Maximum value is 50")
});
